export default "__VITE_ASSET__DsPM$0rR__"